// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"b4a6405a","703":"8529959a"}[chunkId] + ".chunk.js";
};